export default __webpack_public_path__ + "static/media/Shelli_Brunswick_AHV_In_Moms_We_Trust.76c07120.jpg";